import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mb_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

http.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error?.config?.url || "";
    if (error?.response?.status === 401 && !url.includes("/auth/")) {
      clearToken();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const api = {
  // auth
  login: (username, password) => http.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  // settings
  getSettings: () => http.get("/settings").then((r) => r.data),
  updateSettings: (data) => http.put("/settings", data).then((r) => r.data),
  // clients
  listClients: () => http.get("/clients").then((r) => r.data),
  createClient: (data) => http.post("/clients", data).then((r) => r.data),
  updateClient: (id, data) => http.put(`/clients/${id}`, data).then((r) => r.data),
  deleteClient: (id) => http.delete(`/clients/${id}`).then((r) => r.data),
  // rides
  listRides: () => http.get("/rides").then((r) => r.data),
  createRide: (data) => http.post("/rides", data).then((r) => r.data),
  updateRide: (id, data) => http.put(`/rides/${id}`, data).then((r) => r.data),
  deleteRide: (id) => http.delete(`/rides/${id}`).then((r) => r.data),
  // invoices
  listInvoices: () => http.get("/invoices").then((r) => r.data),
  createInvoice: (data) => http.post("/invoices", data).then((r) => r.data),
  invoiceFromRides: (data) => http.post("/invoices/from-rides", data).then((r) => r.data),
  combineInvoices: (data) => http.post("/invoices/combine", data).then((r) => r.data),
  bulkInvoiceStatus: (ids, status) => http.post("/invoices/bulk-status", { ids, status }).then((r) => r.data),
  updateInvoice: (id, data) => http.put(`/invoices/${id}`, data).then((r) => r.data),
  deleteInvoice: (id) => http.delete(`/invoices/${id}`).then((r) => r.data),
  listInvoiceTrash: () => http.get("/invoices/trash").then((r) => r.data),
  restoreInvoice: (id) => http.post(`/invoices/trash/${id}/restore`).then((r) => r.data),
  purgeInvoice: (id) => http.delete(`/invoices/trash/${id}`).then((r) => r.data),
  // quotes
  listQuotes: () => http.get("/quotes").then((r) => r.data),
  createQuote: (data) => http.post("/quotes", data).then((r) => r.data),
  updateQuote: (id, data) => http.put(`/quotes/${id}`, data).then((r) => r.data),
  deleteQuote: (id) => http.delete(`/quotes/${id}`).then((r) => r.data),
  convertQuote: (id) => http.post(`/quotes/${id}/convert`).then((r) => r.data),
  // transport orders (bons de transport)
  listTransportOrders: () => http.get("/transport-orders").then((r) => r.data),
  createTransportOrder: (data) => http.post("/transport-orders", data).then((r) => r.data),
  updateTransportOrder: (id, data) => http.put(`/transport-orders/${id}`, data).then((r) => r.data),
  deleteTransportOrder: (id) => http.delete(`/transport-orders/${id}`).then((r) => r.data),
  // dashboard
  getDashboard: () => http.get("/dashboard").then((r) => r.data),
};
